import React, { useState } from 'react'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import defaultTexts from '../../../texts/texts'
import constants from '../../../config/constants'
import useWindowDimensions from '../../_common/WindowDimesnions'
import billingTexts from '../../../texts/billingTexts'
import BillingDashboard from './analytics/billingDashboard'
import BillingAccounting from './analytics/billingAccounting'

const BillingAnalyticsWrapper = (props) => {
  const { billingServices } = props
  const theme = useTheme()
  const { width } = useWindowDimensions()

  const [activeTab, setActiveTab] = useState('dashboard')

  const labelStyle = {
    color: theme.palette.vodka,
    fontSize: width >= constants.lgBreakpoint ? '18px' : '16px',
    fontWeight: '500',
  }

  const labelArrowStyle = {
    color: theme.palette.oxfordBlue,
  }

  const tabButtonStyle = {
    fontSize: width >= constants.lgBreakpoint ? '18px' : '16px',
    fontWeight: '500',
    textTransform: 'capitalize',
    textDecoration: 'underline',

    '&:hover': {
      background: 'inherit',
      textDecoration: 'none',
    },
  }

  const handleChangeTab = (value) => {
    setActiveTab(value)
  }

  return (
    <>
      <Stack
        direction={{ xs: 'column', lg: 'row' }}
        alignItems={{ xs: 'flex-start', lg: 'center' }}
        justifyContent='space-between'
        sx={{
          padding: '20px 20px 40px 20px',
        }}
      >
        <Box>
          <Stack
            direction='row'
            alignItems='center'
            justifyContent='flex-start'
            spacing={3}
          >
            <Box sx={labelStyle}>{defaultTexts.accounting}</Box>
            <ArrowForwardIosIcon fontSize='small' sx={labelArrowStyle} />
            <Box sx={labelStyle}>{defaultTexts.billing}</Box>
          </Stack>
        </Box>
        <Box>
          <Stack
            direction='row'
            alignItems='center'
            justifyContent='flex-end'
            spacing={3}
          >
            <Button
              variant='text'
              disableRipple
              disableElevation
              sx={{ ...tabButtonStyle, color: activeTab === 'dashboard' ? theme.palette.oxfordBlue : theme.palette.vodka }}
              onClick={() => handleChangeTab('dashboard')}
            >
              {billingTexts.submenuBillingAnalyticsDashboard}
            </Button>

            <Button
              variant='text'
              disableRipple
              disableElevation
              sx={{ ...tabButtonStyle, color: activeTab === 'accounting' ? theme.palette.oxfordBlue : theme.palette.vodka }}
              onClick={() => handleChangeTab('accounting')}
            >
              {billingTexts.submenuBillingAnalyticsAccounting}
            </Button>
          </Stack>
        </Box>        
      </Stack>
      
      <Box sx={{ padding: '0px 20px 20px 10px' }}>
        {
          activeTab === 'dashboard' &&
          <BillingDashboard
            billingServices={billingServices}
          />
        }

        {
          activeTab === 'accounting' &&
          <BillingAccounting />
        }
      </Box>
    </>
  )
}

export default BillingAnalyticsWrapper